import { useState } from 'react';
import './ContactForms.css';

const COUNTRY_CODE_OPTIONS = [
  { value: '+972', label: '🇮🇱 ישראל (+972)' },
  { value: '+1', label: '🇺🇸 ארה"ב (+1)' },
  { value: '+44', label: '🇬🇧 בריטניה (+44)' },
  { value: '+49', label: '🇩🇪 גרמניה (+49)' },
  { value: '+33', label: '🇫🇷 צרפת (+33)' },
  { value: '+39', label: '🇮🇹 איטליה (+39)' },
  { value: '+34', label: '🇪🇸 ספרד (+34)' },
  { value: '+31', label: '🇳🇱 הולנד (+31)' },
  { value: '+41', label: '🇨🇭 שוויץ (+41)' },
  { value: '+43', label: '🇦🇹 אוסטריה (+43)' },
  { value: '+32', label: '🇧🇪 בלגיה (+32)' },
  { value: '+46', label: '🇸🇪 שוודיה (+46)' },
  { value: '+47', label: '🇳🇴 נורווגיה (+47)' },
  { value: '+45', label: '🇩🇰 דנמרק (+45)' },
  { value: '+358', label: '🇫🇮 פינלנד (+358)' },
  { value: '+7', label: '🇷🇺 רוסיה (+7)' },
  { value: '+86', label: '🇨🇳 סין (+86)' },
  { value: '+81', label: '🇯🇵 יפן (+81)' },
  { value: '+82', label: '🇰🇷 דרום קוריאה (+82)' },
  { value: '+91', label: '🇮🇳 הודו (+91)' },
  { value: '+61', label: '🇦🇺 אוסטרליה (+61)' },
  { value: '+64', label: '🇳🇿 ניו זילנד (+64)' },
  { value: '+27', label: '🇿🇦 דרום אפריקה (+27)' },
  { value: '+971', label: '🇦🇪 איחוד האמירויות (+971)' },
  { value: '+966', label: '🇸🇦 ערב הסעודית (+966)' },
  { value: '+20', label: '🇪🇬 מצרים (+20)' },
  { value: '+90', label: '🇹🇷 טורקיה (+90)' },
  { value: '+351', label: '🇵🇹 פורטוגל (+351)' },
  { value: '+353', label: '🇮🇪 אירלנד (+353)' },
  { value: '+48', label: '🇵🇱 פולין (+48)' },
  { value: '+420', label: '🇨🇿 צ\'כיה (+420)' },
  { value: '+36', label: '🇭🇺 הונגריה (+36)' },
  { value: '+40', label: '🇷🇴 רומניה (+40)' },
  { value: '+30', label: '🇬🇷 יוון (+30)' },
];

const EMPTY_DOWNLOAD = {
  fullName: '',
  devicePlatform: 'iphone',
  phone: '',
  countryCode: '+972',
  email: '',
};

const EMPTY_CONTACT = {
  fullName: '',
  contactMethod: 'phone',
  phone: '',
  countryCode: '+972',
  email: '',
  availableTimes: [{ date: '', fromTime: '', toTime: '' }],
};

function ContactForms() {
  const [formMode, setFormMode] = useState('download');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successPopup, setSuccessPopup] = useState(null);
  const [downloadForm, setDownloadForm] = useState(EMPTY_DOWNLOAD);
  const [contactForm, setContactForm] = useState(EMPTY_CONTACT);

  const handleDownloadChange = (field, value) => {
    setDownloadForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleContactChange = (field, value) => {
    setContactForm((prev) => ({ ...prev, [field]: value }));
  };

  const addTimeSlot = () => {
    setContactForm((prev) => ({
      ...prev,
      availableTimes: [...prev.availableTimes, { date: '', fromTime: '', toTime: '' }],
    }));
  };

  const updateTimeSlot = (index, field, value) => {
    setContactForm((prev) => ({
      ...prev,
      availableTimes: prev.availableTimes.map((slot, i) => {
        if (i !== index) return slot;
        const next = { ...slot, [field]: value };
        if (field === 'fromTime' && next.toTime && value && next.toTime < value) {
          next.toTime = '';
        }
        return next;
      }),
    }));
  };

  const removeTimeSlot = (index) => {
    setContactForm((prev) => ({
      ...prev,
      availableTimes: prev.availableTimes.filter((_, i) => i !== index),
    }));
  };

  const openSuccess = (name, purpose) => {
    setSuccessPopup({
      name: String(name || '').trim() || 'אורח/ת',
      purpose,
    });
  };

  const handleDownloadSubmit = (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);
    // UI only for now — no backend connection
    const name = downloadForm.fullName.trim();
    setDownloadForm(EMPTY_DOWNLOAD);
    openSuccess(name, 'download');
    setIsSubmitting(false);
  };

  const handleContactSubmit = (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);
    // UI only for now — no backend connection
    const name = contactForm.fullName.trim();
    setContactForm(EMPTY_CONTACT);
    openSuccess(name, 'talk');
    setIsSubmitting(false);
  };

  return (
    <>
      <section className="app-download-section" id="join">
        <div className="container">
          <div className="contact-section-heading">
            <p className="section-kicker">צרו קשר</p>
            <h2 className="section-title" style={{ maxWidth: 'none', marginInline: 'auto', textAlign: 'center' }}>
              הורדה או שיחה — אנחנו כאן
            </h2>
            <p className="contact-section-subtitle">
              בחרו איך נוח לכם: לקבל לינק להורדת האפליקציה, או לתאם שיחה איתנו.
            </p>
          </div>

          <div className="contact-mode-toggle" role="tablist" aria-label="בחירת סוג פנייה">
            <button
              type="button"
              role="tab"
              aria-selected={formMode === 'download'}
              className={`contact-mode-btn${formMode === 'download' ? ' active' : ''}`}
              onClick={() => setFormMode('download')}
            >
              רוצה להוריד את האפליקציה
            </button>
            <button
              type="button"
              role="tab"
              aria-selected={formMode === 'talk'}
              className={`contact-mode-btn${formMode === 'talk' ? ' active' : ''}`}
              onClick={() => setFormMode('talk')}
            >
              רוצים לדבר איתנו
            </button>
          </div>

          <div className="contact-inline-form">
            {formMode === 'download' ? (
              <form className="download-link-form" onSubmit={handleDownloadSubmit}>
                <div className="form-group form-group--name">
                  <label htmlFor="download-fullName">שם מלא</label>
                  <div className="input-shell">
                    <span className="input-shell-icon" aria-hidden="true">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                        <circle cx="12" cy="7" r="4" />
                      </svg>
                    </span>
                    <input
                      id="download-fullName"
                      type="text"
                      value={downloadForm.fullName}
                      onChange={(e) => handleDownloadChange('fullName', e.target.value)}
                      placeholder="איך קוראים לכם?"
                      required
                    />
                  </div>
                </div>

                <div className="form-group form-group--device">
                  <label>איזה מכשיר יש לך?</label>
                  <div className="radio-group">
                    <label className={`contact-method-option${downloadForm.devicePlatform === 'iphone' ? ' selected' : ''}`}>
                      <input
                        type="radio"
                        name="downloadDevicePlatform"
                        value="iphone"
                        checked={downloadForm.devicePlatform === 'iphone'}
                        onChange={(e) => handleDownloadChange('devicePlatform', e.target.value)}
                      />
                      <span className="method-icon" aria-hidden="true">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <rect x="7" y="2" width="10" height="20" rx="2" ry="2" />
                          <line x1="12" y1="18" x2="12.01" y2="18" />
                        </svg>
                      </span>
                      <span className="method-text">
                        <span className="method-title">אייפון</span>
                        <span className="method-hint">iOS / App Store</span>
                      </span>
                    </label>
                    <label className={`contact-method-option${downloadForm.devicePlatform === 'android' ? ' selected' : ''}`}>
                      <input
                        type="radio"
                        name="downloadDevicePlatform"
                        value="android"
                        checked={downloadForm.devicePlatform === 'android'}
                        onChange={(e) => handleDownloadChange('devicePlatform', e.target.value)}
                      />
                      <span className="method-icon" aria-hidden="true">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <rect x="5" y="2" width="14" height="20" rx="2" ry="2" />
                          <line x1="12" y1="18" x2="12.01" y2="18" />
                        </svg>
                      </span>
                      <span className="method-text">
                        <span className="method-title">אנדרואיד</span>
                        <span className="method-hint">Google Play</span>
                      </span>
                    </label>
                  </div>
                </div>

                <div className="form-group form-group--contact">
                  <label htmlFor="download-email">מייל שמחובר לחנות האפליקציות בטלפון</label>
                  <div className="input-shell">
                    <span className="input-shell-icon" aria-hidden="true">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                        <polyline points="22,6 12,13 2,6" />
                      </svg>
                    </span>
                    <input
                      id="download-email"
                      type="email"
                      value={downloadForm.email}
                      onChange={(e) => handleDownloadChange('email', e.target.value)}
                      placeholder="name@example.com"
                      required
                    />
                  </div>
                </div>

                <div className="form-group form-group--contact">
                  <label htmlFor="download-phone">
                    טלפון <span className="optional-label">(אופציונלי)</span>
                  </label>
                  <div className="phone-input-container">
                    <div className="input-shell phone-number-shell">
                      <input
                        id="download-phone"
                        type="tel"
                        value={downloadForm.phone}
                        onChange={(e) => handleDownloadChange('phone', e.target.value)}
                        placeholder="מספר טלפון"
                      />
                    </div>
                    <select
                      value={downloadForm.countryCode}
                      onChange={(e) => handleDownloadChange('countryCode', e.target.value)}
                      className="country-code-select"
                      aria-label="קידומת מדינה"
                    >
                      {COUNTRY_CODE_OPTIONS.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <button type="submit" className="submit-contact" disabled={isSubmitting}>
                  <span className="submit-contact-label">
                    {isSubmitting ? 'שולח...' : 'שלח לי לינק'}
                  </span>
                  {!isSubmitting && (
                    <span className="submit-contact-arrow" aria-hidden="true">
                      ←
                    </span>
                  )}
                </button>
              </form>
            ) : (
              <form onSubmit={handleContactSubmit}>
                <div className="form-group form-group--name">
                  <label htmlFor="contact-fullName">שם מלא</label>
                  <div className="input-shell">
                    <span className="input-shell-icon" aria-hidden="true">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                        <circle cx="12" cy="7" r="4" />
                      </svg>
                    </span>
                    <input
                      id="contact-fullName"
                      type="text"
                      value={contactForm.fullName}
                      onChange={(e) => handleContactChange('fullName', e.target.value)}
                      placeholder="איך קוראים לכם?"
                      required
                    />
                  </div>
                </div>

                <div className="form-group form-group--method">
                  <label>אמצעי יצירת קשר מועדף</label>
                  <div className="radio-group">
                    <label className={`contact-method-option${contactForm.contactMethod === 'phone' ? ' selected' : ''}`}>
                      <input
                        type="radio"
                        name="contactMethod"
                        value="phone"
                        checked={contactForm.contactMethod === 'phone'}
                        onChange={(e) => handleContactChange('contactMethod', e.target.value)}
                      />
                      <span className="method-icon" aria-hidden="true">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
                        </svg>
                      </span>
                      <span className="method-text">
                        <span className="method-title">טלפון</span>
                        <span className="method-hint">שיחה או הודעה</span>
                      </span>
                    </label>
                    <label className={`contact-method-option${contactForm.contactMethod === 'email' ? ' selected' : ''}`}>
                      <input
                        type="radio"
                        name="contactMethod"
                        value="email"
                        checked={contactForm.contactMethod === 'email'}
                        onChange={(e) => handleContactChange('contactMethod', e.target.value)}
                      />
                      <span className="method-icon" aria-hidden="true">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                          <polyline points="22,6 12,13 2,6" />
                        </svg>
                      </span>
                      <span className="method-text">
                        <span className="method-title">מייל</span>
                        <span className="method-hint">תכתובת נוחה</span>
                      </span>
                    </label>
                  </div>
                </div>

                {contactForm.contactMethod === 'phone' ? (
                  <div className="form-group form-group--contact">
                    <label htmlFor="contact-phone">טלפון</label>
                    <div className="phone-input-container">
                      <div className="input-shell phone-number-shell">
                        <input
                          id="contact-phone"
                          type="tel"
                          value={contactForm.phone}
                          onChange={(e) => handleContactChange('phone', e.target.value)}
                          placeholder="מספר טלפון"
                          required
                        />
                      </div>
                      <select
                        value={contactForm.countryCode}
                        onChange={(e) => handleContactChange('countryCode', e.target.value)}
                        className="country-code-select"
                        aria-label="קידומת מדינה"
                      >
                        {COUNTRY_CODE_OPTIONS.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                ) : (
                  <div className="form-group form-group--contact">
                    <label htmlFor="contact-email">מייל</label>
                    <div className="input-shell">
                      <span className="input-shell-icon" aria-hidden="true">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                          <polyline points="22,6 12,13 2,6" />
                        </svg>
                      </span>
                      <input
                        id="contact-email"
                        type="email"
                        value={contactForm.email}
                        onChange={(e) => handleContactChange('email', e.target.value)}
                        placeholder="name@example.com"
                        required
                      />
                    </div>
                  </div>
                )}

                <div className="form-group form-group--times">
                  <label className="times-main-label">זמנים פנויים</label>
                  {contactForm.availableTimes.map((timeSlot, index) => (
                    <div key={index} className="time-slot-container" style={{ '--slot-i': index }}>
                      <div className="time-slot-header">
                        <h4 className="time-slot-title">
                          <span className="time-slot-badge">{index + 1}</span>
                          זמן פנוי
                        </h4>
                        {contactForm.availableTimes.length > 1 && (
                          <button
                            type="button"
                            className="remove-time"
                            onClick={() => removeTimeSlot(index)}
                            title="הסר זמן"
                          >
                            ✕
                          </button>
                        )}
                      </div>

                      <div className="date-picker-section">
                        <label className="time-label">תאריך</label>
                        <input
                          type="date"
                          value={timeSlot.date}
                          onChange={(e) => updateTimeSlot(index, 'date', e.target.value)}
                          className="date-input"
                          min={new Date().toISOString().split('T')[0]}
                          required
                        />
                      </div>

                      <div className="time-pickers-section">
                        <div className="time-picker-group">
                          <label className="time-label">משעה</label>
                          <input
                            type="time"
                            className="time-input"
                            value={timeSlot.fromTime}
                            onChange={(e) => updateTimeSlot(index, 'fromTime', e.target.value)}
                            required
                          />
                        </div>
                        <div className="time-picker-group">
                          <label className="time-label">עד שעה</label>
                          <input
                            type="time"
                            className="time-input"
                            value={timeSlot.toTime}
                            onChange={(e) => updateTimeSlot(index, 'toTime', e.target.value)}
                            disabled={!timeSlot.fromTime}
                            min={timeSlot.fromTime || undefined}
                          />
                        </div>
                      </div>
                    </div>
                  ))}
                  <button type="button" className="add-time-button" onClick={addTimeSlot}>
                    <span className="add-icon">+</span>
                    הוסף זמן נוסף
                  </button>
                </div>

                <button type="submit" className="submit-contact" disabled={isSubmitting}>
                  <span className="submit-contact-label">
                    {isSubmitting ? 'שולח...' : 'שלחו אלינו'}
                  </span>
                  {!isSubmitting && (
                    <span className="submit-contact-arrow" aria-hidden="true">
                      ←
                    </span>
                  )}
                </button>
              </form>
            )}
          </div>
        </div>
      </section>

      {successPopup && (
        <div className="contact-popup-overlay success-popup-overlay" onClick={() => setSuccessPopup(null)}>
          <div
            className="contact-popup success-popup"
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-modal="true"
            aria-labelledby="success-popup-title"
          >
            <button
              type="button"
              className="close-popup"
              onClick={() => setSuccessPopup(null)}
              aria-label="סגירה"
            >
              ✕
            </button>

            <div className="success-popup-icon" aria-hidden="true">
              <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" stroke="#ffc915" strokeWidth="2" fill="none" />
                <path
                  d="M8 12l2 2 4-4"
                  stroke="#383c7f"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>

            <h2 id="success-popup-title" className="success-popup-title">
              היי {successPopup.name}!
            </h2>
            <p className="success-popup-message">
              {successPopup.purpose === 'download'
                ? 'הפרטים התקבלו בהצלחה. נחזור אליך עם לינק להורדת האפליקציה בהקדם.'
                : 'הפרטים התקבלו בהצלחה. ניצור איתך קשר בהקדם האפשרי.'}
            </p>

            <button
              type="button"
              className="success-popup-close-btn"
              onClick={() => setSuccessPopup(null)}
            >
              סגירה
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default ContactForms;
